<template>
  <div :class="['dashboard-layout', darkMode ? 'dark' : 'light']">
    <!-- SIDEBAR -->
    <SidebarParceiro
      :sidebarColapsada="sidebarColapsada"
      :sidebarAberta="sidebarAberta"
      :darkMode="darkMode"
      @toggle-collapse="toggleSidebarCollapse"
      @logout="logout"
      @voltar-site="voltarSite"
    />

    <!-- OVERLAY (fecha menu no mobile) -->
    <div
      v-if="sidebarAberta"
      class="overlay"
      @click="sidebarAberta=false"
    />

    <!-- CONTEÚDO -->
    <main
      class="main-content"
      :class="{
        collapsed: sidebarColapsada && !isMobile,
        expanded: !sidebarColapsada && !isMobile,
        mobileOpen: sidebarAberta && isMobile
      }"
    >
      <header class="header-dashboard">
        <button class="btn-menu" @click="toggleSidebarMobile">
          <Menu :size="22" />
        </button>

        <div class="header-title">
          <h1>Dashboard</h1>
          <p>Painel Administrativo</p>
        </div>

        <div class="header-actions">
          <button @click="toggleDarkMode" class="btn-theme">
            <Sun v-if="darkMode" :size="18" />
            <Moon v-else :size="18" />
          </button>
          <span class="user-label">👤 Visitante</span>
        </div>
      </header>

      <section class="dashboard-content">
        <router-view />
      </section>
    </main>
  </div>
</template>

<script>
import { Menu, Sun, Moon } from "lucide-vue-next";
import SidebarParceiro from "@/components/dashboard/SidebarParceiro.vue";

export default {
  name: "DashboardLayout",
  components: { SidebarParceiro, Menu, Sun, Moon },
  data() {
    return {
      sidebarColapsada: false,
      sidebarAberta: false,
      darkMode: false,
      isMobile: false,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 1024;
      if (!this.isMobile) this.sidebarAberta = false; // garante que não fique “meio aberto”
    },
    toggleSidebarCollapse() {
      if (this.isMobile) return; // no mobile usamos apenas abrir/fechar
      this.sidebarColapsada = !this.sidebarColapsada;
    },
    toggleSidebarMobile() {
      this.sidebarAberta = !this.sidebarAberta;
    },
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
    },
    logout() {
      alert("Logout realizado!");
    },
    voltarSite() {
      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
/* Layout base */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  transition: background .3s ease, color .3s ease;
}
.dashboard-layout.light { background:#f8fafc; color:#0a1a3a; }
.dashboard-layout.dark  { background:#0f172a; color:#e5e7eb; }

/* Overlay mobile */
.overlay{
  position: fixed; inset:0; background:rgba(0,0,0,.45); z-index:99;
}

/* Conteúdo com recuos dinâmicos */
.main-content{
  flex:1; transition: margin-left .3s ease;
  margin-left:250px; /* desktop padrão (sidebar aberta) */
}
.main-content.collapsed { margin-left:80px; }
.main-content.expanded  { margin-left:250px; }

/* no mobile o conteúdo sempre ocupa 100% */
@media (max-width:1024px){
  .main-content, .main-content.collapsed, .main-content.expanded {
    margin-left:0;
  }
  .main-content.mobileOpen{
    filter: blur(0); /* mantemos só overlay para bloquear clique */
  }
}

/* Header */
.header-dashboard{
  display:flex; align-items:center; justify-content:space-between;
  padding:1rem 1.25rem; background:transparent;
  border-bottom:1px solid rgba(0,0,0,.06);
}
.dashboard-layout.dark .header-dashboard{
  border-bottom:1px solid rgba(255,255,255,.08);
}
.header-title h1{ margin:0; font-size:1.25rem; font-weight:800; }
.header-title p{ margin:.15rem 0 0; font-size:.85rem; opacity:.75; }
.btn-menu,.btn-theme{ background:none; border:none; color:inherit; cursor:pointer; }

.dashboard-content{ padding:1rem; }

/* Aumenta contraste geral no light */
.dashboard-layout.light .header-title h1{ color:#0a1a3a; }
.dashboard-layout.light .header-title p{ color:#334155; }
</style>
